import { render, staticRenderFns } from "./LMSCourseCard.vue?vue&type=template&id=3404862a&scoped=true&"
import script from "./LMSCourseCard.vue?vue&type=script&lang=js&"
export * from "./LMSCourseCard.vue?vue&type=script&lang=js&"
import style0 from "./LMSCourseCard.vue?vue&type=style&index=0&id=3404862a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3404862a",
  null
  
)

export default component.exports